import { imprimirResumoMercadorias } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = false) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 8, query);
  }

  const dados = await buscarDadosImpressao(id, 8);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(
    id,
    'resumo_mercadorias',
    comandos,
  );
  return response.data; */

  return await imprimirResumoMercadorias({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query: '',
  });
}

export default imprimir;
